/* @flow */
import React from 'react';
import { Container } from 'flux/utils';

import BoxBody from 'components/BoxBody';
import Dialog from 'components/Dialog';
import Messages from 'collections/Messages';
import GroupScheduledMessageList from 'groups/components/GroupScheduledMessageList';
import MessageStore from 'groups/stores/MessageStore';
import { getGroupKey, EVERYONE } from 'utils/roleHelpers';

import type { OrganizationTarget, GroupTarget } from 'entities/Message';

type Props = {
  messagesScheduled: Messages,
  groupId: Backbone$Id,
  target: OrganizationTarget | GroupTarget,
};

type State = {
  messagesScheduled: Messages,
};

class ScheduledAnnouncementsDialog extends React.Component<Props, State> {
  static getStores() {
    return [MessageStore];
  }

  static calculateState(prevState, props) {
    const { groupId, target } = props;
    const role = target ? target.role : EVERYONE;

    if (groupId) {
      return {
        messagesScheduled: MessageStore.getMessagesScheduled(getGroupKey(groupId, role)),
      };
    }

    return {};
  }

  constructor(props) {
    super(props);
    this.state = {
      messagesScheduled: props.messagesScheduled,
    };
  }

  render() {
    return (
      <Dialog
        eventScreenName="ScheduledAnnouncementsDialog"
        {...this.props}
        className="ScheduledAnnouncementsDialog"
        title="Scheduled Announcements"
        size="medium">
        <BoxBody>
          {// we have to check for non null here because MessageStore is a leaky abstraction.
          this.state.messagesScheduled && this.state.messagesScheduled.isEmpty() === false ? (
            <GroupScheduledMessageList
              messages={this.state.messagesScheduled}
              target={this.props.target}
            />
          ) : null}
        </BoxBody>
      </Dialog>
    );
  }
}

export default Container.create(ScheduledAnnouncementsDialog, {
  withProps: true,
  pure: false,
});
